<template>
  <div>

  <v-menu
      offset-y
      :internal-activator="true"
      v-model="openMenu"
      content-class="menu__active-code--filter no-contain overflow-visible"
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <div style="width: fit-content;margin-right:10px;position:absolute;right:20px;top:95px">
        <v-btn style="margin-right: 10px;" color="primary" dark v-on="on">
          <span>Lọc theo điều kiện</span>
          <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
        </v-btn>
      </div>
    </template>
    <filter-form
        :activeCodeList="activeCodeList"
        :statusActiveCodeType="statusActiveCodeType"
        :statusActiveCodeList="statusActiveCodeList"
        :filterForm="filterForm"
        :openMenu="openMenu">
    </filter-form>
  </v-menu>

  <template>
    <active-code-table
      :activeCodeList="activeCodeList"
      :statusActiveCodeList="statusActiveCodeList"
    ></active-code-table>
    <v-col cols="12" sm="12">
      <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          :length="getTotalItem(totalItem, limit)"
          class="justify-sm-end"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
      />
    </v-col>
  </template>
  </div>
</template>
<script>
import AgencyRepository from "../../../../repositories/AgencyRepository";
import FilterForm from "./components/FilterForm";
import ActiveCodeTable from "./components/ActiveCodeTable";

export default {
  components: { FilterForm, ActiveCodeTable },
  props: {

  },
  data() {
    return {
      currentPage: 1,
      totalItem: 0,
      limit: 10,
      filterForm: {
        agencyId: this.$route.params.id ? this.$route.params.id : '',
        activeCode: '',
        createdAt: [],
        activatedAt: [],
        staffName: '',
        status: '',
        activationPhone: '',
        typeOfCode: 2, // Mã đại lý
        type: '',
        fromActivationAt: '',
        toActivationAt: '',
        fromCreatedAt: '',
        toCreatedAt: '',
        checkboxAll: false,
        activeCodeIds: []
      },
      statusActiveCodeList: [
        {
          name: 'Đã kích hoạt',
          code: 'active'
        },
        {
          name: 'Chưa kích hoạt',
          code: 'pending'
        },
        {
          name: 'Ngừng hoạt động',
          code: 'inactive'
        }
      ],
      statusActiveCodeType: [
        {
          id: 1,
          name: 'Dùng một lần'
        },
        {
          id: 2,
          name: 'Dùng nhiều lần'
        }
      ],
      openMenu: false,
      activeCodeList: []
    }
  },
  created() {
    Promise.all([
      this.getListActiveCode()
    ]);
    Bus.$on('active-code-list-filter', (filterForm) => {
      // this.filterForm = filterForm;
      this.currentPage = 1;
      this.getListActiveCode();
    });
    Bus.$on('close-menu-filter-active-code', () => {
      this.openMenu = false;
    })
  },
  methods: {
    async getListActiveCode () {
      const loading = this.$loading.show()
      const params = {
        agencyId: this.filterForm.agencyId,
        activeCode: this.filterForm.activeCode,
        staffName: this.filterForm.staffName,
        status: this.filterForm.status,
        activationPhone: this.filterForm.activationPhone,
        typeOfCode: this.filterForm.typeOfCode, // Mã đại lý
        type: this.filterForm.type,
        fromActivationAt: this.filterForm.activatedAt[0] ? this.filterForm.activatedAt[0] : '',
        toActivationAt: this.filterForm.activatedAt[1] ? this.filterForm.activatedAt[1] : '',
        fromCreatedAt: this.filterForm.createdAt[0] ? this.filterForm.createdAt[0] : '',
        toCreatedAt: this.filterForm.createdAt[1] ? this.filterForm.createdAt[1] : '',
        page: this.currentPage - 1,
        limit: this.limit
      }
      const res = await AgencyRepository.listActiveCode(params)
      if (res.success) {
        this.activeCodeList = _.get(res, 'data', []).map(item => {
          return {
            ...item,
            checkbox: false
          }
        })
        this.totalItem = _.get(res, 'totalItem', 0)
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      loading.hide()
    }
  },
  watch: {
    currentPage: {
      handler () {
        this.getListActiveCode()
      },
    },
    limit: {
      handler () {
        if (this.currentPage === 1) {
          this.getListActiveCode()
        } else {
          this.currentPage = 1
        }
      },
    },
  },
};
</script>

<style scoped>
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
/deep/ .menu__active-code--filter {
  width: fit-content;
}
</style>